import hero_img from "../assets/images/hero_img.png";

const IMG = {hero_img};


export { IMG };